import { render, staticRenderFns } from "./proDetail.vue?vue&type=template&id=13f20600&scoped=true"
import script from "./proDetail.vue?vue&type=script&lang=js"
export * from "./proDetail.vue?vue&type=script&lang=js"
import style0 from "./proDetail.vue?vue&type=style&index=0&id=13f20600&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f20600",
  null
  
)

export default component.exports